import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "link"];

  connect() {
    this.linkTargets.forEach((link) => {
      if (link.dataset.turboFrame) {
        link.dataset.action = "dropdown#hideMenu";
      }
    });
  }

  toggleMenu() {
    this.menuTarget.dataset.hidden = this.menuTarget.dataset.hidden !== "true";
  }

  hideMenu() {
    this.menuTarget.dataset.hidden = true;
  }

  closeOnClick(event) {
    if (event && this.element.contains(event.target)) return

    this.hideMenu();
  }
}
